
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'ActivationToggle',
    props: {
        isActive: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    methods: {
        handleToggle(event: Event) {
            const target = event.target as HTMLInputElement
            this.$emit('toggle', target.checked)
        },
    },
})
